import React, { useEffect } from 'react';
import { Card, CardBody, Col, Row } from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import { fetchTotalRevenue } from '../../store/actions';
// import { formatCurrency } from '../Utility/numberUtils'; // Create this helper

const RevenueCard = () => {
    const dispatch = useDispatch();
    const totalRevenue = useSelector(state => state.transactions.totalRevenue);

    useEffect(() => {
      dispatch(fetchTotalRevenue()); // Only fetch the total revenue
    }, [dispatch]);
  return (
    <Card className="mb-4">
      <CardBody>
        <Row className="align-items-center">
          <Col xs="auto">
            <div className="avatar-sm rounded-circle bg-primary bg-soft">
              <i className="bx bx-money font-size-24 text-primary"></i>
            </div>
          </Col>
          <Col>
            <h4 className="mb-1">إجمالي الإيرادات</h4>
            <h2 className="text-primary mb-0">
            {totalRevenue || 0} ر.س
            </h2>
            <p className="text-muted mb-0">من الفواتير المدفوعة</p>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default RevenueCard;